/* Svensk katalog for locale-sales-no.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'adv.sales.productsShowMore': 'Visa mer',
  'adv.sales.productsNote': 'Beloppet under Störst omsättning är fakturerad försäljning per produkt under valt år. Ökning och minskning visar procentuell förändring i omsättning för samma produkt året innan. Produkter utan jämförbara siffror från i fjol visas inte under ökning och minskning.',
  'adv.sales.productsPage': 'Sida {page} av {pages}',
  'adv.sales.productsPrevious': 'Föregående sida för {label}',
  'adv.sales.productsNext': 'Nästa sida för {label}',
  'adv.sales.scn.adjust.priceUp': 'Prishöjning',
  'adv.sales.scn.adjust.volumeDown': 'Minskad försäljningsvolym',
  'sale.doc.invoice': 'Ny faktura',
  'sale.doc.quote': 'Ny offert',
  'sale.doc.orderConfirmation': 'Ny orderbekräftelse',
  'sale.doc.creditNote': 'Ny kreditfaktura',
  'sale.doc.other': 'Annan försäljning',
  'sale.howToCreate': 'Hur vill du skapa {document}?',
  'sale.docIndefinite.invoice': 'en faktura',
  'sale.docIndefinite.quote': 'en offert',
  'sale.docIndefinite.orderConfirmation': 'en orderbekräftelse',
  'sale.docIndefinite.creditNote': 'en kreditfaktura',
  'sale.docIndefinite.other': 'en annan försäljning',
  'sale.credit.title': 'Kreditering',
  'sale.credit.help': 'En kreditfaktura återför en försäljning. Beloppen anges positivt som på en faktura — Plumme vänder tecknet i bokföringen, så att försäljningsintäkt och utgående moms minskar och kundfordran krediteras.',
  'sale.credit.reason': 'Orsak till kreditering',
  'sale.credit.reasonHint': 'Obligatoriskt. Underlaget ska visa vad som faktiskt hände, inte bara beloppet.',
  'sale.credit.reasonPh': 'Retur av vara, prisavdrag, felfakturering ...',
  'sale.credit.link': 'Koppla till faktura',
  'sale.credit.linkHint': 'Valfritt. Om du kopplar hämtas fakturanumret automatiskt och kreditfakturan kvittas mot fakturans utestående belopp.',
  'sale.credit.linkNone': 'Ingen koppling – fritt tillgodobelopp',
  'sale.credit.linkSearchPh': 'Sök på fakturanummer, kund eller belopp ...',
  'sale.credit.linkNoMatches': 'Inga fakturor matchar sökningen',
  'sale.credit.linkShowMore': 'Visa fler fakturor',
  'sale.credit.invoiceOption': 'Faktura {number} · {customer}',
  'sale.credit.invoiceOptionMeta': '{date} · {amount}',
  'sale.credit.linkLocked': 'Valt från fakturan',
  'sale.credit.noNumber': 'Utan nummer',
  'sale.credit.reference': 'Gäller (ursprunglig försäljning)',
  'sale.credit.referenceHint': 'Obligatoriskt utan fakturakoppling. Ange fakturanummer, avtal, period eller system som försäljningen låg i.',
  'sale.credit.referencePh': 'T.ex. faktura 1042 eller ”avtal 2025-04”',
  'sale.credit.linkedTo': 'Krediterar faktura {document}',
  'sale.credit.offsetBadge': 'Kvittas automatiskt',
  'sale.credit.freeHint': 'Utan koppling står beloppet kvar som kundens tillgodobelopp. Du kan kvitta det mot en faktura eller betala tillbaka det från fakturalistan.',
  'sale.credit.date': 'Kreditfakturadatum',
  'sale.credit.numberLabel': 'Kreditfakturanr:',
  'sale.credit.amount': 'Belopp att tillgodo',
  'sale.credit.previewNote': 'Beloppet är krediterat. Det kvittas mot utestående belopp eller betalas tillbaka.',
  'sale.credit.previewReason': 'Orsak:',
  'sale.credit.previewReference': 'Gäller:',
  'sale.credit.set': 'Ange detaljer',
  'sale.credit.edit': 'Ändra',
  'sale.credit.missing': 'Orsak och referens till ursprunglig försäljning måste anges innan kreditfakturan kan skapas.',
  'sale.credit.noReference': 'Ingen referens angiven',
  'sale.credit.freeBadge': 'Fritt tillgodobelopp',
  'sale.credit.needReason': 'Skriv orsaken till krediteringen först',
  'sale.credit.needReference': 'Koppla till en faktura eller ange vilken ursprunglig försäljning kreditfakturan gäller',
  'sale.credit.needDetails': 'Ange orsak och koppla till en faktura eller ange den ursprungliga försäljningen först',
  'sale.credit.create': 'Skapa kreditfaktura',
  'sale.det.period': 'Period',
  'sale.det.subscriptionFrom': 'Abonnemang från',
  'sale.det.subscriptionTo': 'Abonnemang till',
  'sale.det.rentFrom': 'Hyra från',
  'sale.det.rentTo': 'Hyra till',
  'sale.lines.descShortPh': 'T.ex. konsulttimme eller abonnemang',
  'sale.from': 'Från',
  'sale.to': 'Till',
  'sale.use': 'Använd',
  'sale.swap': 'Byt',
  'sale.show': 'Visa',
  'sale.edit': 'Redigera',
  'sale.download': 'Ladda ner',
  'sale.send': 'Skicka',
  'sale.add': 'Lägg till',
  'sale.save': 'Spara',
  'sale.saveChanges': 'Spara ändringar',
  'sale.thisSale': 'denna försäljning',
  'sale.step.kunde': 'Kund',
  'sale.step.bilag': 'Verifikation',
  'sale.step.detaljer': 'Detaljer',
  'sale.step.linjer': 'Rader',
  'sale.step.forhandsvisning': 'Förhandsgranskning',
  'sale.title': 'Försäljning / Faktura / Offert',
  'sale.titleHelp': 'Registrera försäljning, skapa faktura, offert eller orderbekräftelse',
  'sale.docTypeHelpTitle': 'Dokumenttyp',
  'sale.docTypeHelp': 'Välj vilken typ av försäljningsdokument du skapar. Faktura är ett betalningskrav till kunden. Offert är ett icke-bindande prisförslag. Orderbekräftelse bekräftar en avtalad beställning. Annan försäljning används för försäljning utanför systemet, där du laddar upp en verifikation som dokumentation.',
  'sale.stepsHelpTitle': 'Stegen i försäljningen',
  'sale.stepsHelp': 'Försäljningen är uppdelad i fyra steg: Kund, Detaljer, Rader och Förhandsgranskning (för Annan försäljning: Verifikation, Detaljer, Rader och Förhandsgranskning). Tryck på ett steg för att hoppa dit. Ett steg markeras om något saknas innan dokumentet kan skapas.',
  'sale.viewHelpTitle': 'Byt vy',
  'sale.viewHelpToOnePage': 'Byter från det stegvisa flödet till en samlad sida där alla fält visas på en gång, bredvid en levande förhandsgranskning. Snabbare när du är van vid formuläret.',
  'sale.viewHelpToSteps': 'Byter från en samlad sida till ett lugnt stegvis flöde där du fyller i en sak i taget — kund, detaljer, rader och förhandsgranskning. Bra när du vill ha vägledning på vägen.',
  'sale.toOnePage': 'Byt till allt på en sida',
  'sale.toSteps': 'Byt till steg för steg',
  'sale.stepByStep': 'Steg för steg',
  'sale.previewHelpTitle': 'Förhandsgranskning',
  'sale.previewHelp': 'Här ser du hur det färdiga dokumentet ser ut för kunden — med avsändare, kundinformation, rader och totalsumma. Det uppdateras medan du fyller i, så att du kan kontrollera allt innan du skapar eller skickar.',
  'sale.previewToggleHelp': 'Visar eller döljer den levande förhandsgranskningen bredvid formuläret. Dölj den om du vill ha mer plats för fälten.',
  'sale.previewHide': 'Dölj förhandsgranskning',
  'sale.previewShow': 'Visa förhandsgranskning',
  'sale.previewHeading': 'Så här ser dokumentet ut',
  'sale.backToVouchers': 'Tillbaka till transaktioner',
  'sale.resetTitle': 'Återställ formuläret och börja om',
  'sale.reset': 'Återställ',
  'sale.resetDone': 'Formuläret har återställts',
  'sale.back': 'Tillbaka',
  'sale.next': 'Nästa',
  'sale.draftSaved': 'Utkast sparat',
  'sale.draftSavedHelp': 'Utkastet ligger i fakturalistan som det ser ut nu. Om du ändrar något kan du spara igen — det uppdaterar samma utkast.',
  'sale.saveDraft': 'Spara utkast',
  'sale.saveDraftHelpTitle': 'Spara utkast',
  'sale.saveDraftHelp': 'Sparar försäljningen som ett utkast i fakturalistan utan att skicka eller skapa den. Du kan fortsätta där du slutade senare.',
  'sale.saveDraftHelpLong': 'Sparar försäljningen som ett utkast i fakturalistan utan att skicka eller skapa den. Du kan tryggt lämna sidan och fortsätta där du slutade senare.',
  'sale.saveDraftHelpShort': 'Sparar försäljningen som ett utkast i fakturalistan utan att skicka eller skapa den. Du kan tryggt lämna sidan och fortsätta senare.',
  'sale.drafts': 'Utkast',
  'sale.draftsTitle': 'Påbörjade försäljningar som du inte har skapat ännu',
  'sale.noDrafts': 'Inga utkast',
  'sale.searchDrafts': 'Sök i utkast...',
  'sale.deleteDraft': 'Ta bort utkast',
  'sale.deleteDraftTitle': 'Ta bort utkast?',
  'sale.deleteDraftBody': 'Är du säker på att du vill ta bort utkastet för {customer}? Detta kan inte ångras.',
  'sale.det.help': 'Datum, referenser och kommentar för dokumentet. Fakturadatum/förfallodatum styr när fordran gäller och förfaller. ”Vår referens” är handläggaren hos er, ”Er referens” är kundens projekt eller kontaktperson. För faktura kan du också slå på återkommande, så att den skickas automatiskt varje period.',
  'sale.det.date': 'Datum',
  'sale.det.due': 'Förfaller',
  'sale.det.ourRef': 'Vår referens',
  'sale.det.ourRefPh': 'T.ex. handläggare hos oss',
  'sale.det.theirRef': 'Er referens',
  'sale.det.theirRefPh': 'Er referens / projekt',
  'sale.det.payTo': 'Betala till',
  'sale.det.payToHelp': 'Bankkontot som kunden ska betala fakturan till. Listan visar de bankkonton du har sparat — fakturakontot från inställningarna är förvalt, och du kan lägga till ett nytt konto direkt härifrån.',
  'sale.det.payToDefault': 'Fakturakonto',
  'sale.det.payToEmpty': 'Inget bankkonto sparat',
  'sale.det.payToAdd': '+ Lägg till bankkonto ...',
  'sale.det.comment': 'Kommentar',
  'sale.det.commentPh': 'Valfri kommentar som visas på dokumentet',
  'sale.det.savedComments': 'Sparade kommentarer',
  'sale.det.saveComment': 'Spara kommentar',
  'sale.det.useComment': 'Använd kommentar',
  'sale.det.noSavedComments': 'Inga sparade kommentarer ännu.',
  'sale.det.deliveryFrom': 'Leverans-/utförandeperiod - Från',
  'sale.det.deliveryTo': 'Leverans-/utförandeperiod - Till',
  'sale.det.repeating': 'Återkommande',
  'sale.det.repeatingHelpTitle': 'Återkommande faktura',
  'sale.det.repeatingHelp': 'Slå på för att fakturan ska skickas automatiskt med jämna mellanrum — till exempel varje månad vid abonnemang. Du väljer intervall och förfallodag, så skapar och skickar Plumme en ny faktura varje period utan att du behöver göra något.',
  'sale.det.sentEvery': 'Skickas varje',
  'sale.period.week': 'Vecka',
  'sale.period.month': 'Månad',
  'sale.period.quarter': 'Kvartal',
  'sale.period.year': 'Årligen',
  'sale.det.sameDay': 'Samma dag',
  'sale.lines.help': 'Varorna och tjänsterna i försäljningen. Varje rad har antal, pris, momssats och eventuell rabatt, och radsumman räknas ut automatiskt. Välj en sparad produkt eller skriv fritext, och dra i handtaget till vänster för att ändra ordningen.',
  'sale.lines.add': 'Lägg till rad',
  'sale.lines.product': 'Produkt',
  'sale.lines.productPh': 'Sök eller skriv ny produkt...',
  'sale.lines.noProductMatch': 'Inga sparade produkter matchar',
  'sale.lines.editProduct': 'Redigera produkt',
  'sale.lines.productName': 'Produktnamn',
  'sale.lines.description': 'Beskrivning',
  'sale.lines.descriptionPh': 'Valfri beskrivning av produkten/raden',
  'sale.lines.qty': 'Antal',
  'sale.lines.vat': 'Moms',
  'sale.lines.discount': 'Rabatt',
  'sale.lines.netSum': 'Radsumma exkl. moms',
  'sale.lines.toggleVat': 'Växla mellan exkl. och inkl. moms',
  'sale.lines.more': 'Mer',
  'sale.lines.less': 'Mindre',
  'sale.lines.searchAccount': 'Sök konto...',
  'sale.lines.noAccountMatch': 'Inga konton matchar sökningen.',
  'sale.lines.pickAccount': 'Välj konto',
  'sale.lines.searchProductPh': 'Sök på namn eller beskrivning...',
  'sale.sum.help': 'Totalen för hela försäljningen: summa exklusive moms, plus moms, är lika med beloppet kunden ska betala. Siffrorna uppdateras automatiskt när du ändrar raderna.',
  'sale.att.title': 'Bilagor',
  'sale.att.upload': 'Ladda upp bilaga',
  'sale.att.drop': 'Dra filer hit',
  'sale.att.dropHint': 'Bilder eller PDF, eller klistra in',
  'sale.att.pickFile': 'Välj fil',
  'sale.att.dropToAdd': 'Släpp bilagan för att lägga till den',
  'sale.att.dragTip': 'Tips: du kan också dra filer direkt in på sidan.',
  'sale.att.forgot': 'Har du glömt några verifikationer? Släpp verifikationen här',
  'sale.att.fromInbox': 'Hämta från inkorgen',
  'sale.att.uploadInstead': 'Ladda upp verifikation i stället',
  'sale.att.view': 'Se verifikationen',
  'sale.att.openPreview': 'Öppna i förhandsgranskning',
  'sale.send.title': 'Skickar dokument',
  'sale.send.to': 'Skicka till',
  'sale.send.replyTo': 'Svara till',
  'sale.send.asPdf': 'Skicka som PDF-bilaga',
  'sale.send.asLink': 'Skicka som länk',
  'sale.send.pdfHint': 'Kunden får dokumentet direkt i e-postmeddelandet.',
  'sale.send.linkHint': 'Ger lässtatus när kunden öppnar dokumentet.',
  'sale.send.how': 'Hur ska dokumentet skickas?',
  'sale.send.newRecipient': 'Ny e-postadress …',
  'sale.send.saveContact': 'Spara som kontaktperson hos {customer}',
  'sale.send.thisCustomer': 'kunden',
  'sale.send.contactName': 'Namn',
  'sale.send.contactNamePh': 'Anna Andersson',
  'sale.send.contactRole': 'Roll',
  'sale.send.contactRolePh': 'Ekonomi',
  'sale.send.contactSaveFailed': 'Dokumentet skickades, men kontaktpersonen kunde inte sparas.',
  'sale.send.emailPh': 'namn@exempel.se',
  'sale.send.viewDocument': 'Se dokumentet',
  'sale.preview.sender': 'Avsändare:',
  'sale.preview.invoiceNo': 'Fakturanr:',
  'sale.preview.invoiceDate': 'Fakturadatum:',
  'sale.preview.dueDate': 'Förfallodatum:',
  'sale.preview.ourRef': 'Vår referens:',
  'sale.preview.theirRef': 'Er referens:',
  'sale.preview.comment': 'Kommentar:',
  'sale.preview.accountNo': 'Kontonr:',
  'sale.preview.toPay': 'Att betala:',
  'sale.preview.net': 'Netto',
  'sale.preview.vat': 'Moms',
  'sale.preview.paid': 'Betalt',
  'sale.preview.toPayShort': 'Att betala',
  'sale.preview.receipt': 'Kvitto',
  'sale.preview.paymentHint': 'Vänligen ange fakturanummer vid betalning',
  'sale.preview.currencyNote': 'Alla belopp anges i {currency}',
  'sale.lines.fromDraftDescr': 'Överfört från utkast',
  'sale.att.maxSize': 'En bilaga får vara högst {max}.',
  'sale.att.addedOne': '1 bilaga tillagd',
  'sale.att.addedMany': '{count} bilagor tillagda',
  'sale.comment.deleted': 'Kommentar borttagen',
  'sale.comment.deleteFailed': 'Kunde inte ta bort kommentaren.',
  'sale.comment.writeFirst': 'Skriv en kommentar först',
  'sale.comment.updated': 'Kommentar uppdaterad',
  'sale.comment.saveFailed': 'Kunde inte spara kommentaren.',
  'sale.comment.alreadySaved': 'Kommentaren är redan sparad',
  'sale.comment.saved': 'Kommentar sparad',
  'sale.comment.backendUnavailable': 'Kommentarer är inte kopplade till backend.',
  'sale.det.offerDate': 'Offertdatum',
  'sale.det.orderDate': 'Orderdatum',
  'sale.det.saleDate': 'Försäljningsdatum',
  'sale.det.invoiceDateLabel': 'Fakturadatum',
  'sale.det.validUntil': 'Giltig till',
  'sale.det.dueDateLabel': 'Förfallodatum',
  'sale.textLine.titleUpdate': 'Uppdatera textrad',
  'sale.textLine.titleNewHeading': 'Ny rubrik',
  'sale.textLine.titleNewText': 'Ny textrad',
  'sale.textLine.update': 'Uppdatera',
  'sale.textLine.typeLabel': 'Typ',
  'sale.textLine.typeText': 'Textrad',
  'sale.textLine.typeHeading': 'Rubrik',
  'sale.textLine.nameLabel': 'Namn',
  'sale.textLine.namePhHeading': 'T.ex. Arbete',
  'sale.textLine.namePhText': 'T.ex. Produkt X',
  'sale.textLine.textLabel': 'Text',
  'sale.textLine.textPh': 'Valfri text som visas under raden',
  'sale.textLine.styleFor': 'Stil för {target}',
  'sale.textLine.boldShort': 'F',
  'sale.textLine.italicShort': 'K',
  'sale.textLine.useDivider': 'Använd avdelare',
  'sale.textLine.dividerHint': 'Visa en linje under texten i dokumentet.',
  'sale.textLine.searchPhHeading': 'Sök eller skriv rubrik...',
  'sale.textLine.searchPhText': 'Sök eller skriv textrad...',
  'sale.textLine.noMatch': 'Inga sparade textrader matchar',
  'sale.textLine.addAsHeading': 'Lägg till "{value}" som ny rubrik',
  'sale.textLine.addAsText': 'Lägg till "{value}" som ny textrad',
  'sale.textLine.headingSaved': 'Rubrik sparad',
  'sale.textLine.textSaved': 'Textrad sparad',
  'sale.textLine.headingAdded': 'Rubrik tillagd',
  'sale.textLine.textAdded': 'Textrad tillagd',
  'sale.textLine.saveFailed': 'Kunde inte spara textraden.',
  'sale.det.durationMonth1': '1 månad',
  'sale.det.durationMonth3': '3 månader',
  'sale.det.durationMonth6': '6 månader',
  'sale.det.durationMonth12': '12 månader',
  'sale.lines.typeProduct': 'Produktrad',
  'sale.lines.typeSpacer': 'Mellanrum',
  'sale.lines.noText': 'Utan text',
  'sale.lines.qtyUnit': '{qty} st',
  'sale.preview.receiptNoLabel': 'Kvittonr:',
  'sale.preview.quoteNoLabel': 'Offertnr:',
  'sale.preview.orderNoLabel': 'Ordernr:',
  'sale.preview.backToOther': 'Tillbaka till Annan försäljning',
  'sale.preview.backToInvoice': 'Tillbaka till faktura',
  'sale.preview.vatMoms': 'Moms',
  'sale.preview.continuesNextPage': 'Fortsätter på nästa sida',
  'sale.att.labelWithName': 'Bilaga · {name}',
  'sale.att.dropHere': 'Släpp verifikationen här',
  'sale.att.otherSaleHint': 'Annan försäljning är allmän försäljning utanför systemet - ladda upp en bild eller PDF som dokumentation.',
  'sale.att.previewHint': 'För förhandsgranskning, tryck på en av dina bilagor eller Se kvitto.',
  'sale.att.viewReceipt': 'Se kvitto',
  'sale.att.createReceipt': 'Skapa kvitto',
  'sale.mode.subtitle': 'Välj ett lugnt stegvis flöde, eller behåll alla fält samlade på en sida.',
  'sale.mode.stepsDesc': 'Kund, detaljer, rader och förhandsgranskning - en sak i taget. Bra för nybörjare.',
  'sale.mode.onePageDesc': 'Hela fakturan samlad med levande förhandsgranskning. Snabbt för den erfarne.',
  'sale.draft.noCustomer': 'Utan kund',
  'sale.draft.noMatchesTitle': 'Inga träffar',
  'sale.draft.noMatchesText': 'Inga utkast matchar sökningen.',
  'sale.draft.emptyText': 'Påbörjade försäljningar sparas här när du trycker på Spara utkast.',
  'sale.draft.colSale': 'Försäljning',
  'sale.draft.noNumber': 'Utan nummer',
  'sale.draft.colDate': 'Datum',
  'sale.draft.colAmount': 'Belopp',
  'sale.draft.deleteFailed': 'Kunde inte ta bort utkastet.',
  'sale.draft.saveFailed': 'Kunde inte spara utkastet.',
  'sale.draft.deleteUnavailable': 'Borttagning av utkast är inte kopplad till backend.',
  'sale.draft.onlyDraftsDelete': 'Bara utkast kan tas bort här',
  'sale.draft.deleted': 'Utkast borttaget',
  'sale.draft.saveUnavailable': 'Sparande av utkast är inte kopplat till backend.',
  'sale.draft.savedToList': 'Utkastet är sparat i fakturalistan',
  'sale.create.invoice': 'Skapa faktura',
  'sale.create.quote': 'Skapa offert',
  'sale.create.order': 'Skapa orderbekräftelse',
  'sale.create.other': 'Registrera försäljning',
  'sale.create.needMatchingPartials': 'Summan av delbetalningarna måste stämma med försäljningens total först',
  'sale.create.needLineOrAttachment': 'Lägg till en rad eller en verifikation först',
  'sale.create.needCustomerAndProduct': 'Välj en kund och lägg till minst en produkt först',
  'sale.create.needCustomer': 'Välj en kund först',
  'sale.create.needProduct': 'Lägg till minst en produkt först',
  'sale.create.receiptSendingBackground': 'Kvittot skickas i bakgrunden',
  'sale.create.receiptSentEmail': 'Kvittot skickades via e-post.',
  'sale.create.recurringSaveFailed': 'Fakturan skapades, men det återkommande avtalet kunde inte sparas.',
  'sale.create.createFailed': 'Kunde inte skapa försäljningen.',
  'sale.create.createdTitle': '{doc} {num} har skapats.',
  'sale.create.saleCreatedBody': 'Försäljningen är bokförd. Du kan spara kvittot, skicka dokumentation till kunden eller stänga.',
  'sale.create.docCreatedBody': 'Du kan spara {def} som PDF eller skicka {pron} vidare via e-post.',
  'sale.create.pdfReceiptLabel': 'PDF/Kvitto',
  'sale.create.pdfLabel': 'PDF',
  'sale.send.unavailableSale': 'Utskick är inte tillgängligt för den här försäljningen.',
  'sale.send.unavailableDocument': 'Utskick är inte tillgängligt för det här dokumentet.',
  'sale.send.failed': 'Utskicket misslyckades.',
  'sale.send.customerFallback': 'Kund',
  'sale.send.defaultContactRole': 'Standardkontakt',
  'sale.send.contactFallback': 'Kontaktperson',
  'sale.send.recipientFallback': 'Mottagare',
  'sale.send.receiptTitle': 'Skicka kvitto',
  'sale.send.howToSend': 'Hur vill du skicka {doc}?',
  'sale.send.receiptEmailHint': 'Ange e-postadressen som kvittot ska skickas till.',
  'sale.send.chooseDeliveryHint': 'Välj om kunden ska få en PDF i e-postmeddelandet, eller en länk som Postplumma kan följa.',
  'sale.send.allCustomersInList': 'Alla kunder i listan ({count})',
  'sale.send.needEmailFirst': 'Lägg in e-post på kunden eller en kontaktperson innan du skickar.',
  'sale.send.stepDraftPrep': 'Utkast förbereds',
  'sale.send.stepArriving': 'Postplumma anländer',
  'sale.send.stepSuccess': 'Klart! Postplumma är på väg.',
  'sale.send.receiptReadyNoEmail': 'Kvittot är klart, men inget e-postmeddelande skickades.',
  'sale.send.sendingInBackground': '{doc} skickas i bakgrunden',
  'sale.send.sentAsLinkShort': '{doc} skickades som länk.',
  'sale.send.sentAsLinkTracked': '{doc} skickades som länk. Du kan följa lässtatus i fakturalistan.',
  'sale.send.sentAsEmail': '{doc} skickades via e-post.',
  'sale.send.readyNoEmail': '{doc} är klar, men inget e-postmeddelande skickades.',
  'sale.send.sentToRecipients': 'Skickat till {count} mottagare.',
  'sale.send.notProvided': 'Inte angivet',
  'sale.send.spamTip': 'Tips: Om kunden inte hittar e-postmeddelandet, be dem kolla skräppost/spam.',
  'sale.inboxPicker.tabInbox': 'Inkorg ({count})',
  'sale.inboxPicker.tabDocumentation': 'Dokumentation ({count})',
  'sale.inboxPicker.searchDocumentation': 'Sök i dokumentation',
  'sale.inboxPicker.searchInbox': 'Sök i inkorgen',
  'sale.inboxPicker.selectTip': 'Tips: Håll ned Skift för att välja flera i rad, eller Ctrl/Cmd för att välja enskilt.',
  'sale.inboxPicker.emptyDocumentation': 'Inga dokument matchar sökningen.',
  'sale.inboxPicker.emptyInbox': 'Inga verifikationer i inkorgen matchar sökningen.',
  'sale.inboxPicker.fallbackReceipt': 'Verifikation',
  'sale.inboxPicker.fallbackDocument': 'Dokument',
  'sale.inboxPicker.fallbackDocumentation': 'Dokumentation',
  'sale.lines.subscriptionPeriod': 'Abonnemang - {{period}}',
  'sale.lines.months12': '12 mån',
  'sale.lines.month1': '1 mån',
  'sale.lines.rentalPrice': 'Uthyrning - {{price}}',
  'sale.lines.addAsNewProduct': 'Lägg till "{{value}}" som ny produkt',
  'sale.lines.useDivider': 'Använd avdelare',
  'sale.lines.dividerHint': 'Visa en linje under den här raden i dokumentet.',
  'sale.preview.colDescription': 'Beskrivning',
  'sale.preview.colQty': 'Antal',
  'sale.preview.colPrice': 'Pris',
  'sale.preview.colDiscount': 'Rabatt',
  'sale.preview.colSum': 'Summa',
  'sale.doc.invoiceName': 'Faktura',
  'sale.doc.quoteName': 'Offert',
  'sale.doc.orderConfirmationName': 'Orderbekräftelse',
  'sale.doc.creditNoteName': 'Kreditfaktura',
  'sale.draft.colType': 'Typ',
  'sale.period.every14days': 'Var 14:e dag',
  'sale.det.dueDays': '{{count}} dagar',
  'sale.lines.priceExVat': 'Pris exkl. moms',
  'sale.lines.priceIncVat': 'Pris inkl. moms',
  'sale.lines.lineNumber': 'Rad {{n}}',
  'sale.lines.pickProduct': 'Välj produkt',
  'sale.lines.freeText': 'Fritext',
  'sale.lines.spacerHint': 'En tom rad visas som mellanrum i dokumentet.',
  'sale.lines.chooseLineType': 'Välj radtyp',
  'agreements.notSent': 'Inte skickad',
  'agreements.error.missingCustomerEmail': 'Kunden saknar e-postadress. Lägg in e-post på kunden, så skickas fakturan vid nästa körning.',
  'agreements.error.missingCustomer': 'Kunden finns inte längre eller är arkiverad. Välj en aktiv kund för avtalet.',
  'agreements.warning.missingCustomerEmail': 'Kunden saknar e-postadress',
  'agreements.warning.missingCustomerEmailHelp': 'Automatiskt utskick kräver e-postadress. Lägg in den på kunden före nästa fakturadatum, annars skickas inte fakturan.',
});
